<template>
  <div>
    <NuxtLink
      :to="productLink"
      :aria-label="product.currentTranslation?.title"
      class="block aspect-h-[450] aspect-w-[360]"
    >
      <UiLazyImg
        :src="product.images?.[0]?.url || '/images/no-image.webp'"
        cover
      />
    </NuxtLink>
    <div class="py-2 flex gap-x-3 pr-1">
      <div class="grow">
        <NuxtLink
          :to="productLink"
          class="ui-text-sm font-medium uppercase break-words-custom"
          :class="white ? 'text-white' : 'text-primary'"
        >
          {{ product.currentTranslation?.title }}
        </NuxtLink>
      </div>
      <UiButton
        variant="clear"
        variant-type="icon"
        size="xs"
        :aria-label="$t('addToWishlist')"
        @click="onWishListClick"
      >
        <UiIcon
          name="bookmark"
          class="size-3.5"
          :class="white ? 'fill-white text-white' : 'fill-primary text-primary'"
          aria-hidden="true"
        />
      </UiButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ProductData, CatalogData } from "ecom-types";
import type { WishListData } from "~/composables/_useWishlist";
import { sizesSlugs } from "~/configs";

const props = defineProps<{
  product: CatalogData & { start_at_cost?: number };
  plpType?: string;
  white?: boolean;
}>();

const { productPrice, discountValue, productLink } = useProduct(
  props.product,
  sizesSlugs,
);
const { updateWishlist } = useWishlist();

function onWishListClick() {
  updateWishlist({
    sku: props.product.selected_config?.configuration_id || props.product.variant_plp_image?.sku || props.product.default_sku,
    images: [
      props.product.selected_config?.image?.url ||
      props.product.variant_plp_image?.image?.url ||
        props.product.images?.[0]?.url ||
        "",
    ],
    cost:
      props.product.sale && discountValue.value
        ? discountValue.value
        : productPrice.value,
    slug: props.product.slug,
    configuration_id:
      props.product.selected_config?.configuration_id || props.product.variant_plp_image?.sku || props.product.default_sku,
    engraving: {},
    materials: props.product.materials,
    material_categories: props.product.material_categories,
    material_categories_plp_hover_ids:
      props.product.material_categories_plp_hover_ids,
    translations: props.product.translations as ProductData["translations"],
    active_configurations_count: props.product.active_configurations_count,
    min_cost: props.product.min_cost,
    product_id: props.product.id,
    collection_ids: props.product.collections_ids || [],
    vendor_model: props.product.vendor_model || "",
    start_at_cost: props.product.start_at_cost || 0,
    product_configuration_id:
      props.product.product_configuration_id ||
      props.product.selected_config?.id ||
      props.product.variant_plp_image?.product_configuration_id ||
      props.product.default_config?.id,
  } as WishListData);
}
</script>
